import React from "react"

const ReplyIcon = ({ }) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path fill="none" strokeLinecap="round" strokeLinejoin="round" d="M2 10 C2 10 13 10 16 10 C24 10 24 21 16 21 M2 10 L9 3 M2 10 L9 17" />
</svg>
export default ReplyIcon
